import {NodeDefs} from "../parser/definition/types/NodeDefs";
import {CompilationTargetId} from "../types/CompilationTargetId";
import {compileNodeDef} from "./compileNodeDef";
import {nodeNameToFactoryId} from "./utils/nodeNameToFactoryId";

export function compileFactories(
  nodeDefs: NodeDefs,
  targetId: CompilationTargetId
): string {
  const result: Array<string> = [];
  for (const nodeName in nodeDefs) {
    const nodeDef = nodeDefs[nodeName];
    result.push(compileNodeDef(nodeNameToFactoryId(nodeName), nodeDef, targetId));
  }
  return result.join("\n");
}
